export interface IBusinessUploadedBucketFile {
  key: string;
  location: string;
}

export interface IBusinessSignedUrl {
  location: string;
}
